import * as React from 'react';
import Box from '@mui/material/Box';

const thumbnail = '/new-mangomap-assets/Thumbnail-320x242.png';

export function ItemIcon(): React.JSX.Element {
	return (
		<Box
			sx={{
				overflow: 'hidden',
				borderRadius: 1.5,
				alignItems: 'center',
				display: 'inline-flex',
				flex: '0 0 auto',
				justifyContent: 'center',
				minWidth: '64px',
				minHeight: '64px',
				width: '100%',
				height: '100%',
			}}
		>
			<Box
				alt="Folder"
				component="img"
				src={thumbnail}
				sx={{ objectFit: 'contain' }}
			/>
		</Box>
	);
}
